import { ApiProperty } from '../../codegen';
import { IsOptional, IsString } from '../../validators';

export class OauthDto {
  @ApiProperty({ required: false })
  @IsString({ groups: ['error'] })
  @IsOptional({ groups: ['error'] })
  googleId?: string;

  @ApiProperty({ required: false })
  @IsString({ groups: ['error'] })
  @IsOptional({ groups: ['error'] })
  facebookId?: string;

  @ApiProperty({ required: false })
  @IsString({ groups: ['error'] })
  @IsOptional({ groups: ['error'] })
  discordId?: string;

  @ApiProperty({ required: false })
  @IsString({ groups: ['error'] })
  @IsOptional({ groups: ['error'] })
  linkedinId?: string;

  @ApiProperty({ required: false })
  @IsString({ groups: ['error'] })
  @IsOptional({ groups: ['error'] })
  elamaId?: string;

  @ApiProperty({ required: false })
  @IsString({ groups: ['error'] })
  @IsOptional({ groups: ['error'] })
  vkId?: string;

  @ApiProperty({ required: false })
  @IsString({ groups: ['error'] })
  @IsOptional({ groups: ['error'] })
  yandexId?: string;
}

export class OAuthLoginDto {
  @IsString()
  provider: string;

  @IsString()
  providerId: string;

  @IsString()
  name?: string;

  @IsString()
  email?: string;

  @IsString()
  avatar?: string;
}
